import { ref } from "vue";
import Swal from "sweetalert2";
import i18n from "@/i18n/index";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import { RegulationSalesQueryParams } from "@/interfaces/stats";

 
import {
  PaymentRequest,
  TransactionQueryParams,
  StatusPayementRequest,
} from "@/interfaces/payment";
import {
  transactions,
  clubUUID,
  paginationLinks,
  summary_transactions,
  regulations_amount,
  today_regulations_amount,
  regulations_amount_by_day,
  club_statistic_encaisse,
} from "@/shared/state";
import { useGlobal } from "@/composables/global/useGlobal";
const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function usePayment() {
  const errorPayment = ref<boolean | false>(false);
  const { formatDate } = useGlobal();
  const isRequestPayment = ref<boolean | false>(false);
  const fetchTransactions = async (body: TransactionQueryParams) => {
    try {
      isRequestPayment.value = true;
      errorPayment.value = false;
      transactions.data = [];
      paginationLinks.value = 0;
      const response = await authenticatedFetch(
        `${API_URL}members/transactions/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );

      if (body?.type === "paginate") {
        summary_transactions.data = response?.summary || [];
        transactions.data = response?.transactions?.data || [];
        paginationLinks.value = response?.transactions || [];
        delete paginationLinks.value.data;
      } else if (body?.type === "all") {
        if (response?.summary) {
          summary_transactions.data = response?.summary || {};
          transactions.data = response?.transactions || {};
        } else {
          transactions.data = response || {};
        }
      }
      isRequestPayment.value = false;
    } catch (err: any) {
      errorPayment.value = true;
      isRequestPayment.value = false;
    }
  };
  const fetchTransactionsExportFile = async (body: TransactionQueryParams) => {
    try {
      isRequestPayment.value = true;
      errorPayment.value = false;
      const response = await authenticatedFetch(
        `${API_URL}members/transactions/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );

      if (response) {
        isRequestPayment.value = false;
        return {
          summary_transactions: response?.summary || {},
          transactions: response?.transactions || {},
        };
      }
      isRequestPayment.value = false;
    } catch (err: any) {
      isRequestPayment.value = false;
      errorPayment.value = true;
    }
  };
  const encaissementsPeriodSummary = async () => {
    try {
      isRequestPayment.value = true;
      errorPayment.value = false;
      const response = await authenticatedFetch(
        `${API_URL}encaissements/summary/by-period/${clubUUID.value}`,
        {
          method: "GET",
        },
        false,
        "",
        false,
      );

      if (response) {
        isRequestPayment.value = false;
        club_statistic_encaisse.today = formatDate(response?.data?.today);
        club_statistic_encaisse.month = response?.data?.month;
        club_statistic_encaisse.year = response?.data?.year;
        club_statistic_encaisse.value.today_total =
          response?.data?.value?.today_total ?? 0;
        club_statistic_encaisse.value.month_total =
          response?.data?.value?.month_total ?? 0;
        club_statistic_encaisse.value.year_total =
          response?.data?.value?.year_total ?? 0;
      }
      isRequestPayment.value = false;
    } catch (err: any) {
      isRequestPayment.value = false;
      errorPayment.value = true;
    }
  };

    const decaissementsPeriodSummary = async () => {
      try {
        isRequestPayment.value = true;
        errorPayment.value = false;
        const response = await authenticatedFetch(
          `${API_URL}decaissements/summary/by-period/${clubUUID.value}`,
          {
            method: "GET",
          },
          false,
          "",
          false,
        );

        if (response) {
          isRequestPayment.value = false;
          club_statistic_encaisse.today = formatDate(response?.data?.today);
          club_statistic_encaisse.month = response?.data?.month;
          club_statistic_encaisse.year = response?.data?.year;
          club_statistic_encaisse.value.today_total =
            response?.data?.value?.today_total ?? 0;
          club_statistic_encaisse.value.month_total =
            response?.data?.value?.month_total ?? 0;
          club_statistic_encaisse.value.year_total =
            response?.data?.value?.year_total ?? 0;
        }
        isRequestPayment.value = false;
      } catch (err: any) {
        isRequestPayment.value = false;
        errorPayment.value = true;
      }
    };
  const fetchRegulationsStatsByDay = async (
    body: RegulationSalesQueryParams,
  ) => {
    try {
      isRequestPayment.value = true;
      errorPayment.value = false;
      regulations_amount_by_day.data = [];
      const response = await authenticatedFetch(
        `${API_URL}members/regulations/stats`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        isRequestPayment.value = false;
        regulations_amount_by_day.data = response?.regulations;
        regulations_amount_by_day.total = response?.total;
      }
      isRequestPayment.value = false;
    } catch (err: any) {
      errorPayment.value = true;
      isRequestPayment.value = false;
    }
  };

  const fetchRegulationsStats = async (body: RegulationSalesQueryParams) => {
    try {
      isRequestPayment.value = true;
      errorPayment.value = false;
      regulations_amount.data = [];
      const response = await authenticatedFetch(
        `${API_URL}members/regulations/stats`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        isRequestPayment.value = false;
        regulations_amount.data = response?.regulations;
        regulations_amount.total = response?.total;
      }
      isRequestPayment.value = false;
    } catch (err: any) {
      errorPayment.value = true;
      isRequestPayment.value = false;
    }
  };
  const fetchRegulationsStatsToday = async (
    body: RegulationSalesQueryParams,
  ) => {
    try {
      isRequestPayment.value = true;
      errorPayment.value = false;
      today_regulations_amount.data = [];
      const response = await authenticatedFetch(
        `${API_URL}members/regulations/stats`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );
      if (response) {
        isRequestPayment.value = false;
        today_regulations_amount.data = response?.regulations;
        today_regulations_amount.total = response?.total;
      }
      isRequestPayment.value = false;
    } catch (err: any) {
      errorPayment.value = true;
      isRequestPayment.value = false;
    }
  };

  // const editMember = async (body: MemberRequest) => {
  //     try {
  //         const response = await authenticatedFetch(`${API_URL}members/edit/${body?.id}/${clubUUID.value}`, {
  //             method: 'PUT',
  //             body: JSON.stringify(body),
  //         }, true);
  //         if (response) {
  //             const memberEdited: Member = response?.data
  //             const index = members?.data?.findIndex(member => member?.id === memberEdited?.id);
  //             if (index !== -1) {
  //                 members.data[index] = memberEdited;
  //             }
  //         }
  //     } catch (err: any) {
  //         errorPayment.value = true;
  //     }
  // };

  // const deleteSubscriptionMember = async (id: number) => {
  //     try {
  //         const response = await authenticatedFetch(`${API_URL}member/delete/${id}/${clubUUID.value}`, {
  //             method: 'DELETE'
  //         }, true);
  //         const index = members?.data?.findIndex(member => member?.id === id);
  //         if (index !== -1) {
  //             members.data.splice(index, 1);
  //         }
  //     } catch (err: any) {
  //         errorPayment.value = true;
  //     }
  // };

  const regulationSubscription = async (body: PaymentRequest) => {
    try {
      isRequestPayment.value = true;
      errorPayment.value = false;
      const customToastMessage = i18n.t("message.toast.paid.title");
      const response = await authenticatedFetch(
        `${API_URL}member/payment/subscribe`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        customToastMessage,
        true,
      );
      if (response) {
        isRequestPayment.value = false;
        return response;
      }
      
      isRequestPayment.value = false;
    } catch (err: any) {
      isRequestPayment.value = false;
      errorPayment.value = true;
    }
  };

  const deletePayment = async (id: number) => {
    try {
      isRequestPayment.value = true;
      errorPayment.value = false;
      const response = await authenticatedFetch(
        `${API_URL}member/payment/delete/${id}/${clubUUID.value}`,
        {
          method: "DELETE",
        },
        true,
        "",
        true,
      );
      if (response) {
        //  
        return true;
      }
    } catch (err: any) {
      isRequestPayment.value = false;
      errorPayment.value = true;
    } finally {
      isRequestPayment.value = false;
      errorPayment.value = true;
    }
  };

  const changeStatus = async (body: StatusPayementRequest) => {
    try {
      isRequestPayment.value = true;
      errorPayment.value = false;
      const customToastMessage = i18n.t("message.toast.registration.title");
      const response = await authenticatedFetch(
        `${API_URL}member/payment/status/${clubUUID.value}`,
        {
          method: "PUT",
          body: JSON.stringify(body),
        },
        true,
        customToastMessage,
        true,
      );
      if (response) {
        isRequestPayment.value = false;
        return response;
      } else {
        isRequestPayment.value = false;
      }
    } catch (err) {
      isRequestPayment.value = false;
      errorPayment.value = true;
    }
  };
  return {
    changeStatus,
    fetchRegulationsStatsToday,
    encaissementsPeriodSummary,
    decaissementsPeriodSummary,
    regulationSubscription,
    fetchTransactions,
    fetchRegulationsStatsByDay,
    fetchRegulationsStats,
    fetchTransactionsExportFile,
    isRequestPayment,
    deletePayment,
    errorPayment,
  };
}
